// extracted by mini-css-extract-plugin
export default {"milestoneList":"milestone-list_milestoneList__ZvYSm"};